import React from 'react';
import { Section } from '../ui/Section';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function Benefits() {
  const personal = ['Más claridad mental en las primeras 72 horas', 'Descansás sin culpa', 'Terminás el día con energía que te alcanza', 'Sentís alivio mental en una semana'];
  const daily = ['Te cuesta menos arrancar cada tarea', 'Llegás menos drenada al final del día', 'Sentís orden interno sin exigirte más'];
  return <Section background="light-peach" className="text-center" data-id="element-11">
      <h2 className="text-4xl md:text-5xl font-serif italic text-navy mb-6" data-id="element-12">
        Resultados que vas a notar rápido
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto mt-14 text-left" data-id="element-13">
        {/* En vos */}
        <div className="bg-cream/50 p-8 rounded-[2rem] border border-dusty-rose/20" data-id="element-14">
          <h3 className="text-sm font-bold text-dusty-rose mb-6 uppercase tracking-widest" data-id="element-15">
            En vos
          </h3>
          <div className="space-y-5" data-id="element-16">
            {personal.map((item, i) => <motion.div key={i} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-17">
                <div className="bg-warm-gold/10 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-18">
                  <Check className="w-4 h-4 text-warm-gold" data-id="element-19" />
                </div>
                <p className="text-base text-navy font-light leading-relaxed" data-id="element-20">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* En tu vida diaria */}
        <div className="bg-cream/50 p-8 rounded-[2rem] border border-dusty-rose/20" data-id="element-21">
          <h3 className="text-sm font-bold text-dusty-rose mb-6 uppercase tracking-widest" data-id="element-22">
            En tu vida diaria
          </h3>
          <div className="space-y-5" data-id="element-23">
            {daily.map((item, i) => <motion.div key={i} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1,
            duration: 0.5
          }} viewport={{
            once: true
          }} data-id="element-24">
                <div className="bg-warm-gold/10 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-25">
                  <Check className="w-4 h-4 text-warm-gold" data-id="element-26" />
                </div>
                <p className="text-base text-navy font-light leading-relaxed" data-id="element-27">
                  {item}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Mecanismo único */}
      <motion.div className="mt-16 max-w-2xl mx-auto bg-cream rounded-[2rem] p-8 md:p-10 border border-dusty-rose/30 shadow-sm" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} data-id="element-28">
        <h3 className="text-2xl md:text-3xl font-serif italic text-navy mb-4" data-id="element-29">
          El mecanismo único
        </h3>
        <p className="text-base md:text-lg text-muted font-light leading-relaxed" data-id="element-30">
          El Método Energía Real te enseña a detectar y cerrar las fugas de
          energía invisibles. No se trata de hacer más, sino de{' '}
          <span className="font-serif italic font-medium text-warm-gold text-xl" data-id="element-31">
            liberar la energía que ya tenés
          </span>
          , para que te sientas liviana en menos de una semana.
        </p>
      </motion.div>
    </Section>;
}